import styled from "styled-components";

export const PopoverContainer = styled("div").attrs((props: any) => ({
  open: props.open,
}))`
  display: ${({ open }) => (open ? "flex" : "none")};
  z-index: 999;
`;
